module.exports = __webpack_public_path__ + "static/media/user.101e43b2.jpg";